import React, { useState, useEffect } from "react";
import Wrappers from "../shared/Wrappers";
import Header from "./Header";
import FilterButtons from "../shared/FilterButtons";
import CompletedJob from "./CompletedJob";
import CancelledJob from "./CancelledJob";
import OnGoing from "./OnGoing";
import { GetAllJobs } from "../../../services/admin/jobhistory";
import Loader from "../../shared/loader";
import SharedHeaders from "../shared/SharedHeaders";
import NotFoundIcon from "../../shared/NotFoundIcon";

const JobHistoryMain = () => {
  const [loading, setLoading] = useState(false);
  const [AllData, setAllData] = useState([]);
  const [activeButton, setactiveButton] = useState(0);
  const [CurrentPage, setCurrentPage] = useState(1);
  const [SearchInputValue, setSearchInputValue] = useState("");
  const [SelectedDateCallback, setSelectedDateCallback] = useState("");

  const ButtonsArray = [
    { title: "Completed" },
    { title: "Cancelled" },
    { title: "On-Going" },
  ];

  useEffect(() => {
    handleFetchAllDispatchs();
  }, [activeButton, SearchInputValue, SelectedDateCallback, CurrentPage]);

  const handleFetchAllDispatchs = async () => {
    const StatusType = ButtonsArray[activeButton]?.title || "";
    const Search = SearchInputValue || "";
    const Date = SelectedDateCallback || "";
    const Page = CurrentPage || 1;
    await GetAllJobs(setLoading, setAllData, StatusType, Search, Date, Page);
  };

  return (
    <Wrappers>
      {loading && <Loader />}
      {/* <Header /> */}
      <SharedHeaders
        Placeholder="Search for Sender, Receiver, Order"
        SearchInputValue={SearchInputValue}
        setSearchInputValue={setSearchInputValue}
        SelectedDateCallback={SelectedDateCallback}
        setSelectedDateCallback={setSelectedDateCallback}
        HasAccountType={false}
      />
      <FilterButtons
        ButtonsArray={ButtonsArray}
        activeButton={activeButton}
        setactiveButton={setactiveButton}
        setCurrentPage={setCurrentPage}
      />

      {!loading && (
        <>
          {AllData && AllData?.data && AllData?.data?.length > 0 ? (
            <>
              {activeButton === 0 && (
                <CompletedJob
                  data={AllData?.data || []}
                  CurrentPage={CurrentPage}
                  setCurrentPage={setCurrentPage}
                  Last_page={AllData?.last_page}
                  total_pages={AllData?.total_pages}
                />
              )}
              {activeButton === 1 && (
                <CancelledJob
                  data={AllData?.data || []}
                  CurrentPage={CurrentPage}
                  setCurrentPage={setCurrentPage}
                  Last_page={AllData?.last_page}
                  total_pages={AllData?.total_pages}
                />
              )}
              {activeButton === 2 && (
                <OnGoing
                  data={AllData?.data || []}
                  CurrentPage={CurrentPage}
                  setCurrentPage={setCurrentPage}
                  Last_page={AllData?.last_page}
                  total_pages={AllData?.total_pages}
                />
              )}
            </>
          ) : (
            !loading && <NotFoundIcon MT="20" IconWidth="10" />
          )}
        </>
      )}
    </Wrappers>
  );
};

export default JobHistoryMain;
